import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    googleSearchPlaces: [],
    userPlaces: [],
    sessions: [],
    userSessions: [],
    chat: {
      messages: []
    },
    track: {},
    canvas: {},
    conjure: {},
    isShowFocusSessionModal: false
  },
  getters: {
    googleSearchPlaces(state) {
      return state.googleSearchPlaces;
    },
    userPlaces(state) {
      return state.userPlaces;
    },
    sessions(state) {
      return state.sessions;
    },
    chat(state) {
      return state.chat;
    },
    canvas(state) {
      return state.canvas;
    },
    conjure(state) {
      return state.conjure;
    },
    userSessions(state) {
      return state.userSessions;
    },
    isShowFocusSessionModal(state) {
      return state.isShowFocusSessionModal;
    }
  },
  actions: {
    registerForSession({ commit }, { session, form }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionRef = db.doc(`listings/sessions/items/${session.id}`);

        sessionRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let registrations =
                doc.data() && doc.data().registrations
                  ? doc.data().registrations
                  : [];
              session._created_at = new Date();
              sessionRef
                .update({
                  _updated_at: new Date(),
                  registrations: [...registrations, form]
                })
                .then(() => {
                  res(true);
                })
                .catch(error => {
                  rej(error);
                  console.log(`Error  registering user: ${error}`);
                });
            }
          })
          .catch(err => {
            rej(err);
            console.log(`Error  registering user: ${err}`);
          });
      });
    },
    /* CONNECT TOOL */
    getGuideData({ commit }, guideId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const usersRef = db.collection("users");

        return usersRef
          .where("_dashboards.guide.profileName", "==", guideId)
          .get()
          .then(snap => {
            if (snap.docs.length > 0) {
              res({ ...snap.docs[0].data(), userId: snap.docs[0].id });
            } else {
              res(null);
            }
          })
          .catch(err => {
            console.log("error in getting guide data: ", err);
            rej(err);
          });
      });
    },
    createSession({ commit }, session) {
      /* * Creates the session for the session table and session info for guide and for user
       * SESSION -- Session Name, SHEF, date, UniqueRoomId: Guide_User_Timestamp, User, Guide
       * CONDUCTOR -- Session Name, SHEF, date, UniqueRoomId, Guide
       * USER -- Session Name, SHEF, date, UniqueRoomId, Guide
       * */
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.collection("sessions");
        const guideSessionsRef = db.doc(
          `users/${session.guide.user_id}/lists/__guide_sessions`
        );
        const userSessionsRef = db.doc(
          `users/${session.user.user_id}/lists/__sessions`
        );
        const createdAt = new Date();

        session.guide.user_id = db.doc(`users/${session.guide.user_id}`);
        session.user.user_id = db.doc(`users/${session.user.user_id}`);

        let newSessionDoc = sessionsRef.doc();

        return newSessionDoc
          .set({
            ...session,
            _created_at: createdAt
          })
          .then(() => {
            res(true);

            let guideSession = {
              _created_at: createdAt,
              _booked_at: session._booked_at,
              user: session.user,
              session: db.doc(`sessions/${newSessionDoc.id}`),
              plan: session.plan,
              room_id: session.room_id
            };

            guideSessionsRef
              .get()
              .then(doc => {
                if (doc.exists) {
                  return guideSessionsRef.update({
                    sessions: [...doc.data().sessions, guideSession],
                    _updated_at: new Date()
                  });
                } else {
                  return guideSessionsRef.set({
                    _created_at: createdAt,
                    sessions: [guideSession]
                  });
                }
              })
              .catch(err => {
                console.log("error in saving list guide sessions1:", err);
              });

            let userSession = {
              _created_at: createdAt,
              _booked_at: session._booked_at,
              user: session.guide,
              session: db.doc(`sessions/${newSessionDoc.id}`),
              plan: session.plan,
              room_id: session.room_id
            };

            userSessionsRef
              .get()
              .then(doc => {
                if (doc.exists) {
                  return userSessionsRef.update({
                    sessions: [...doc.data().sessions, userSession],
                    _updated_at: new Date()
                  });
                } else {
                  return userSessionsRef.set({
                    _created_at: createdAt,
                    sessions: [userSession]
                  });
                }
              })
              .catch(err => {
                console.log("error in saving list user sessions:", err);
              });
          })
          .catch(err => {
            console.log("error in creating new session:", err);
            rej(err);
          });
      });
    },
    createSessionInvite({ commit }, session) {
      /* * Create the invite session for the session table and session info for guide and for user
       * SESSION -- Session Name, SHEF, date, UniqueRoomId: Guide_User_Timestamp, User, Guide
       * CONDUCTOR -- Session Name, SHEF, date, UniqueRoomId, Guide
       * USER -- Session Name, SHEF, date, UniqueRoomId, Guide
       * */
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.collection("sessions");
        const guideSessionsRef = db.doc(
          `users/${session.guide.user_id}/lists/__guide_sessions`
        );

        const createdAt = new Date();

        session.guide.user_id = db.doc(`users/${session.guide.user_id}`);

        let newSessionDoc = sessionsRef.doc();

        return newSessionDoc
          .set({
            ...session,
            _created_at: createdAt
          })
          .then(() => {
            let guideSession = {
              _created_at: createdAt,
              _booked_at: session._booked_at,
              user: session.user,
              password: session.password,
              geoLocation: session.geoLocation,
              session: db.doc(`sessions/${newSessionDoc.id}`),
              plan: session.plan,
              room_id: session.room_id,
              session_code: session.session_code,
              profileName: session.guide.profileName
            };

            guideSessionsRef
              .get()
              .then(doc => {
                if (doc.exists) {
                  guideSessionsRef
                    .update({
                      sessions: [...doc.data().sessions, guideSession],
                      _updated_at: new Date()
                    })
                    .then(() => {
                      res(true);
                    });
                } else {
                  guideSessionsRef
                    .set({
                      _created_at: createdAt,
                      sessions: [guideSession]
                    })
                    .then(() => {
                      res(true);
                    });
                }
              })
              .catch(err => {
                console.log("error in saving list guide sessions2:", err);
              });
          })
          .catch(err => {
            console.log("error in creating new session:", err);
            rej(err);
          });
      });
    },
    updateGuideSession({ commit }, session) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideSessions = [];
        // const sessionsRef = db.collection("sessions");
        // Update inside Sessions &  User Sessions
        const guideSessionsRef = db.doc(
          `users/${session.guide.user_id}/lists/__guide_sessions`
        );
        guideSessionsRef.get().then(snapShot => {
          guideSessions = snapShot.data().sessions;
          guideSessions.forEach(gSession => {
            if (gSession.room_id == session.room_id) {
              guideSessionsRef
                .update({
                  sessions: firebase.firestore.FieldValue.arrayRemove(gSession)
                })
                .then(() => {
                  gSession.user.firstname = session.user.firstname;
                  gSession.user.lastname = session.user.lastname;
                  gSession.user.email = session.user.email;
                  gSession.user.phoneNumber = session.user.phoneNumber;
                  gSession.plan.title = session.plan.title;
                  gSession.plan.summary = session.plan.summary;
                  gSession.plan.price = session.plan.price;
                  gSession.plan.duration = session.plan.duration;
                  gSession._booked_at = session._booked_at;
                  gSession.password = session.password;
                  gSession.geoLocation = session.geoLocation;
                  guideSessionsRef
                    .update({
                      sessions: firebase.firestore.FieldValue.arrayUnion(
                        gSession
                      )
                    })
                    .then(() => {
                      res(true);
                      console.log("Session updated");
                    });
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating session:", e);
                });
            }
          });
        });
      });
    },
    getSessions({ commit }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.collection("sessions");

        return sessionsRef
          .get()
          .then(snap => {
            let sessions = snap.docs.map(el => el.data());
            res(sessions);
            commit("SET_SESSIONS", sessions);
          })
          .catch(err => {
            console.log("error in get sessions data: ", err);
            rej(err);
          });
      });
    },
    getSessionsForUser({ commit }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.collection("sessions");

        return sessionsRef
          .where("guide", "==", db.doc(`users/${userId}`))
          .get()
          .then(snap => {
            let sessions = snap.docs.map(el => el.data());
            res(sessions);
            commit("SET_SESSIONS", sessions);
          })
          .catch(err => {
            console.log("error in get sessions data: ", err);
            rej(err);
          });
      });
    },
    getUserSessions({ commit, rootState }, userId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const sessionsRef = db.collection("sessions");
        let newDate = new Date();

        return (
          sessionsRef
            .where("user", "==", db.doc(`users/${rootState.user.user.uid}`))
            //.where("_booked_at", ">", newDate)
            .get()
            .then(snap => {
              let sessions = snap.docs.map(el => el.data());
              res(sessions);
              commit("SET_USER_SESSIONS", sessions);
            })
            .catch(err => {
              console.log("error in get sessions data: ", err);
              rej(err);
            })
        );
      });
    },
    getChat({ commit, state }, roomId) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let chatRef = db.doc(`sessions_rooms/${roomId}/tools/chat`);

        chatRef
          .get()
          .then(doc => {
            if (doc.exists) {
              chatRef.onSnapshot(doc => {
                // console.log("Current data: ", doc.data());
                commit("SET_CHAT", doc.data());
                res(doc.data());
              });
            } else {
              chatRef
                .set({
                  _created_at: new Date(),
                  messages: []
                })
                .then(doc => {
                  chatRef.onSnapshot(doc => {
                    // console.log("Current data: ", doc.data());
                    commit("SET_CHAT", doc.data());
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in saving list guide sessions 3:", err);
          });
      });
    },
    addChatMsg({ commit, state }, { roomId, message }) {
      const db = firebase.firestore();
      let chatRef = db.doc(`sessions_rooms/${roomId}/tools/chat`);

      chatRef
        .update({
          messages: firebase.firestore.FieldValue.arrayUnion(message)
        })
        .then(function(data) {
          console.log("Data has been logged");
        })
        .catch(function(error) {
          console.error("Error adding message: ", error);
        });
    },
    setChatIsTyping({ commit, state }, { roomId, userId, isTyping }) {
      const db = firebase.firestore();
      let chatRef = db.doc(`sessions_rooms/${roomId}/tools/chat`);

      chatRef
        .update({
          users: {
            [userId]: {
              _updated_at: new Date(),
              isTyping: isTyping
            }
          }
        })
        .then(function(data) {
          console.log("Chat is Typing Updated");
        })
        .catch(function(error) {
          console.error("Error adding isTyping: ", error);
        });
    },
    getCanvas({ commit }, roomId) {
      return new Promise(res => {
        const db = firebase.firestore();
        let canvasRef = db.doc(`sessions_rooms/${roomId}/tools/canvas`);

        canvasRef
          .get()
          .then(doc => {
            if (doc.exists) {
              canvasRef.onSnapshot(doc => {
                // console.log("Current data: ", doc.data());
                commit("SET_CANVAS", doc.data());
                res(doc.data());
              });
            } else {
              canvasRef
                .set({
                  _created_at: new Date(),
                  isOpen: false
                })
                .then(doc => {
                  canvasRef.onSnapshot(doc => {
                    // console.log("Current data: ", doc.data());
                    commit("SET_CANVAS", doc.data());
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in saving list guide sessions4:", err);
          });
      });
    },
    getConjure({ commit }, roomId) {
      return new Promise(res => {
        const db = firebase.firestore();
        let conjureRef = db.doc(`sessions_rooms/${roomId}/tools/conjure`);

        conjureRef
          .get()
          .then(doc => {
            if (doc.exists) {
              conjureRef.onSnapshot(doc => {
                // console.log("Current data: ", doc.data());
                commit("SET_CONJURE", doc.data());
                res(doc.data());
              });
            } else {
              conjureRef
                .set({
                  _created_at: new Date(),
                  isOpen: false
                })
                .then(doc => {
                  conjureRef.onSnapshot(doc => {
                    // console.log("Current data: ", doc.data());
                    commit("SET_CONJURE", doc.data());
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in saving list guide sessions5:", err);
          });
      });
    },
    setCanvasIsOpen({ commit, state }, { roomId, userId, isOpen }) {
      const db = firebase.firestore();
      let canvasRef = db.doc(`sessions_rooms/${roomId}/tools/canvas`);

      canvasRef
        .update({
          _updated_at: new Date(),
          _updated_by: userId,
          isOpen: isOpen
        })
        .then(function(data) {
          console.log("Data has been updated");
        })
        .catch(function(error) {
          console.error("Error adding message: ", error);
        });
    },
    setConjure({ commit }, { roomId, userId, type, interval }) {
      const db = firebase.firestore();
      let conjureRef = db.doc(`sessions_rooms/${roomId}/tools/conjure`);

      conjureRef
        .update({
          _updated_at: new Date(),
          _updated_by: userId,
          type: type,
          interval: interval
        })
        .then(function(data) {
          console.log("Conjure has been sent");
        })
        .catch(function(error) {
          console.error("Error conjuring: ", error);
        });
    },
    getTrack({ commit, state }, { roomId, userId, remoteUserId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let trackRef = db.doc(`sessions_rooms/${roomId}/sessions/track`);

        let tracking = {
          _created_at: new Date(),
          action: "connected",
          user: userId
        };

        trackRef
          .get()
          .then(doc => {
            if (doc.exists) {
              trackRef
                .update({
                  _updated_at: new Date(),
                  actions: [...doc.data().actions, tracking],
                  state: {
                    [userId]: {
                      connection: "connected"
                    },
                    [remoteUserId]: {
                      connection: "connected"
                    }
                  }
                })
                .then(doc => {
                  trackRef.onSnapshot(doc => {
                    // console.log("Current data: ", doc.data());
                    commit("SET_TRACK", doc.data());
                    res(doc.data());
                  });
                });
            } else {
              trackRef
                .set({
                  _created_at: new Date(),
                  actions: [tracking],
                  state: {
                    [userId]: {
                      connection: "connected"
                    },
                    [remoteUserId]: {
                      connection: "connected"
                    }
                  }
                })
                .then(doc => {
                  trackRef.onSnapshot(doc => {
                    // console.log("Current data: ", doc.data());
                    commit("SET_TRACK", doc.data());
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in saving track:", err);
          });
      });
    }
  },
  mutations: {
    // CONNECT
    UPDATE_GOOGLE_SEARCH_PLACES(state, { places }) {
      state.googleSearchPlaces = places;
    },
    SET_USER_PLACES(state, userPlaces) {
      if (userPlaces.length) {
        state.userPlaces = userPlaces;
      } else {
        state.userPlaces = [];
      }
    },
    SET_SESSIONS(state, sessions) {
      state.sessions = sessions;
    },
    SET_CHAT(state, chat) {
      state.chat = chat;
    },
    SET_TRACK(state, track) {
      state.track = track;
    },
    SET_CANVAS(state, canvas) {
      state.canvas = canvas;
    },
    SET_CONJURE(state, conjure) {
      state.conjure = conjure;
    },
    SET_USER_SESSIONS(state, sessions) {
      state.userSessions = sessions;
    },
    SET_IS_SHOW_FOCUS_SESSION_MODAL(state, payload) {
      state.isShowFocusSessionModal = payload;
    }
  }
};
